import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import { createElement } from "react"
import { EmbeddedClerkAuth } from "@/components/embeddedClerkAuth"

export default class extends Controller {
  static values = {
    publishableKey: String,
    redirectUrl: String
  }

  connect() {
    const root = createRoot(this.element)
    root.render(
      createElement(EmbeddedClerkAuth, {
        publishableKey: this.publishableKeyValue,
        redirectUrl: this.redirectUrlValue
      })
    )
    this.root = root
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
    }
  }
}
